import { motion } from 'framer-motion';
import cn from 'classnames';
import { useState } from 'react';
import { ArrowDownIcon } from '~/svgs/common';
type CollapsableSectionProps = {
   title: React.ReactNode;
   children: React.ReactNode;
   wrapperClassName?: string;
};
export const DetailsCollapsableSectionDesktop = ({
   children,
   title,
   wrapperClassName,
}: CollapsableSectionProps) => {
   const [open, setOpen] = useState(false);
   const toggle = () => setOpen(prev => !prev);

   return (
      <div className={wrapperClassName || 'border-t'}>
         <button
            onClick={toggle}
            className="flex justify-between w-full py-3 cursor-pointer hover:bg-gray-100/50 focus:outline-none focus:bg-gray-100/50">
            <div className="prose">
               <h3 className="text-black">{title}</h3>
            </div>
            <div>
               <ArrowDownIcon
                  className={cn('transform scale-50 transition-all mt-1.5', open && 'rotate-180')}
               />
            </div>
         </button>
         <motion.div
            initial="animate"
            animate={open ? 'animate' : 'initial'}
            className="overflow-hidden"
            transition={{ ease: 'easeInOut', duration: 0.25 }}
            variants={{
               initial: { height: 0 },
               animate: { height: 'auto' },
            }}>
            <div className="py-5">{children}</div>
         </motion.div>
      </div>
   );
};
